import React, { useState, useEffect } from 'react';
import YouTube from 'react-youtube';
import './YoutubeMovie.css';

import { Heading } from '../../../components';

const YouTubeMovie = () => { 

    const [width, setWidth] = useState(window.innerWidth * 0.9);
    const [videoHeight, setVideoHeight] = useState((window.innerWidth * 0.9 * 9) / 16);

    useEffect(() => {
        // 更新视频高度的函数
        function handleResize() {
            setWidth(window.innerWidth * 0.9);
            setVideoHeight((window.innerWidth * 0.9 * 9) / 16);
        }

        // 监听窗口大小变化
        window.addEventListener('resize', handleResize);

        // 清理监听器
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const opts = {
        width: width,
        height: videoHeight,
        playerVars: {
        autoplay: 1,
        rel: 0, 
        },
      };
    
      const onReady = (event) => {
        event.target.pauseVideo();
      };
    

    return (
        <section className="youtube-window">
            {/* Section heading */}
            <Heading title={'停車聰明繳費太方便'} subTitle={'省時省力趕快看'} />

            <div className='box-container'> 
                <YouTube videoId="f1YURV19Lho" className="youtube-content" opts={opts} onReady={onReady} className="movie" />  
            </div>

        </section>

    )

}

export default YouTubeMovie



